module.exports = __webpack_public_path__ + "static/media/btn_shadow.0aca89a2.png";